"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _LoadingLabel = _interopRequireDefault(require("../LoadingLabel"));

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    label: function label(_ref) {
      var align = _ref.align;
      return {
        "float": align
      };
    },
    cell: function cell(_ref2) {
      var align = _ref2.align,
          wordBreak = _ref2.wordBreak;
      return {
        textOverflow: 'ellipsis',
        overflowX: 'hidden',
        whiteSpace: wordBreak ? undefined : 'nowrap',
        wordBreak: wordBreak,
        "float": align
      };
    }
  };
});

var TableLoadingLabel = function TableLoadingLabel(_ref3) {
  var render = _ref3.render,
      isLoading = _ref3.isLoading,
      align = _ref3.align,
      wordBreak = _ref3.wordBreak,
      className = _ref3.className,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref3, ["render", "isLoading", "align", "wordBreak", "className"]);
  var classes = useStyles({
    align: align,
    wordBreak: wordBreak
  });

  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_LoadingLabel["default"], {
      width: "70%",
      height: 4,
      className: (0, _classnames["default"])(classes.label),
      "data-testid": "TableLoadingLabel"
    });
  }

  var view = render();
  var value = view === '' || R.isNil(view) ? '-' : view;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.cell, className)
  }, boxProps), value);
};

var _default = TableLoadingLabel;
exports["default"] = _default;